/* globals cpac, unselectProgram, selectProgram, $, $j, Windows */

if (typeof cpac !== 'undefined') {
  // CPAC event page
  cpac.event = {
    // tennis camp group
    campGroup : {}
  }

  cpac.event.campGroups = {
    startDate: '',
    endDate:'',
    earlyDate: '',
        // select tennis camp sessions
    selectSession: function (objSelect)
    {
        try {

            var startDate = '';
            var endDate = '';
            var earlyDate = '';

            for (var i=0; i < objSelect.options.length; i++) {
                if (!objSelect.options[i].selected) {
                    continue;
                }
                    // check start dates
                if (startDate == '') {
                    startDate = objSelect.options[i].getAttribute('start_date');
                } else {
                    if (startDate != objSelect.options[i].getAttribute('start_date')) {
                        alert('Start date does not match');
                        startDate = '';
                        break;
                    }
                }
                    // check end dates
                if (endDate == '') {
                    endDate = objSelect.options[i].getAttribute('end_date');
                } else {
                    if (endDate != objSelect.options[i].getAttribute('end_date')) {
                        alert('End date does not match');
                        endDate = '';
                        break;
                    }
                }
                    // check early registration dates
                if (earlyDate == '') {
                    earlyDate = objSelect.options[i].getAttribute('early_date');
                } else {
                    if (earlyDate != objSelect.options[i].getAttribute('early_date')) {
                        alert('Early registration date does not match');
                        earlyDate = '';
                        break;
                    }
                }
            }

            $('params-start_date').value = startDate;
            $('params-end_date').value = endDate;
            $('params-early_date').value = earlyDate;

        } catch(e) {
            cpac.error(e)
        }
    },
    
    selectMultiSession: function(rowObj, programId, propName, url, defValue, startDate, endDate, earlyDate) {
        try {        
            if (rowObj.className.indexOf('selected_row') > -1) { 
                unselectProgram(programId, propName); 
            } 
            else 
            { 
                selectProgram(programId, propName, url, defValue);  

                if (cpac.event.campGroups.startDate == '') {
                    cpac.event.campGroups.startDate = startDate;
                }
                else {
                    if (startDate != cpac.event.campGroups.startDate) {
                        alert('Start date does not match');
                        startDate = '';
                    }            
                }

                if (cpac.event.campGroups.endDate == '') {
                    cpac.event.campGroups.endDate = endDate;
                }
                else {
                    if (endDate != cpac.event.campGroups.endDate) {
                        alert('End date does not match');
                        endDate = '';
                    }           
                } 

                if (cpac.event.campGroups.earlyDate == '') {
                    cpac.event.campGroups.earlyDate = earlyDate;
                }
                else {
                    if (earlyDate != cpac.event.campGroups.earlyDate) {
                        alert('Early registration date does not match');
                        endDate = '';
                    }           
                }   
                $('season_start_date').value = startDate;
                $('season_end_date').value = endDate;
                $('season_early_date').value = earlyDate;   
            }
        } catch(e) {
            cpac.error(e)
        }    
        var checked_status = 0;
        var inputs = $j('.selected_row_hidden_input');
        $j.each(inputs, function(i, val) {
            if (checked_status == 0 && val.value != 0) {
                checked_status = val.value;
            }
        });
        if (checked_status == 0) {
            cpac.event.campGroups.startDate = '';
            cpac.event.campGroups.endDate = '';
            cpac.event.campGroups.earlyDate = '';
        }
    },

    checkForm: function (formObj)
    {
        try {
            var feeSum = 0;
            var earlyFeeSum = 0;
            var guestFeeSum = 0;
            var earlyGuestFeeSum = 0;
            
            var inputs = $j('.selected_row_hidden_input');
            $j.each(inputs, function(i, val) {
                if (val.value != 0) {
                    feeSum += parseFloat($j('#fee_'+val.value).val());
                    earlyFeeSum += parseFloat($j('#early_fee_'+val.value).val());
                    guestFeeSum += parseFloat($j('#guest_fee_'+val.value).val());
                    earlyGuestFeeSum += parseFloat($j('#guest_early_fee_'+val.value).val());
                }
            });  
            
            if (parseFloat(formObj.fee.value) > feeSum) {
                alert('Group fee cannot be more then sum of fees of selected sessions.');
                return false;
            }
            if (parseFloat(formObj.early_fee.value) > earlyFeeSum) {
                alert('Group Early Registration Fee cannot be more then sum of fees of selected sessions.');
                return false;
            }
            if (parseFloat(formObj.guest_fee.value) > guestFeeSum) {
                alert('Group Guest Fee cannot be more then sum of fees of selected sessions.');
                return false;
            }
            if (parseFloat(formObj.guest_early_fee.value) > earlyGuestFeeSum) {
                alert('Group Early Registration Guest Fee cannot be more then sum of fees of selected sessions.');
                return false;
            }
            return true;
        } catch(e) {
            cpac.error(e)
        }
    }
  }

    cpac.event.copySession = function() {
        var win = Windows.getWindow(window.eventCopySeason);
        if( !win ) {
            win = new Window({
                className: 'alphacube',
                title: 'copy session',
                width: 635,
                closable: true,
                resizable: false,
                minimizable: false,
                maximizable: false,
                destroyOnClose: true
            });
            window.eventCopySeason = win.getId();
        }

        var params = {};
        if( $j('#component').is('input')) params.component = $j('#component').val();
        if( $j('#category').is('input')) params.category = $j('#category').val();
        if( $j('#archived').is('input')) params.archived = $j('#archived').is(':checked');

        if( $j('#season').is('input')) params.from_season = $j('#season').val();
        if( $j('#obj_program').is('input')) {
            params.from_program = $j('#obj_program').val();
            var seasonCol = $j('#program_'+params.from_program+'_list');
            if( seasonCol.is('div')) {
                var seasonVal = seasonCol.find('#obj_session');
                if( seasonVal.is('input')) {
                    params.from_session = seasonVal.val();
                }
            }
        }

        if( params.from_season  && parseInt(params.from_season) > 0
        &&  params.from_program && parseInt(params.from_program) > 0
        &&  params.from_session && parseInt(params.from_session) > 0 ) {
            win.showCenter(true);

            var formContainer = $j('#'+win.getContent().id);
            var loading = $j('<div></div>');
            loading.css({
                background: '#fff url(/public/images/themes/cpac/ajax-loader.gif) center center no-repeat'
                ,width: '635px'
            });
            formContainer.append(loading);

            formContainer.load('/event/copy-session', params, function(){});
        }
    }

    cpac.event.proSchedule = {
        current_action: false, // false/selecting/deselecting
        current_staff: 0,
        current_add_input_num: 0, // for page event/pro-scheduling
    
        selectDate: function (linkObj, staffId, _date)
        {
            var inputObj = $('new_value-' + staffId + '-' + _date);
            if (inputObj) {
                inputObj.value = '1';
                Element.addClassName(linkObj, 'active');
            }
        },
    
        deselectDate: function (linkObj, staffId, _date)
        {
            var inputObj = $('new_value-' + staffId + '-' + _date);
            if (inputObj) {
                inputObj.value = '0';
                Element.removeClassName(linkObj, 'active');
            }
        },
    
        startDragging: function (linkObj, staffId, _date)
        {
            this.current_staff = staffId;
            this.current_action = Element.hasClassName(linkObj, 'active') ? 'deselecting' : 'selecting';
            if (this.current_action == 'selecting') {
                this.selectDate(linkObj, staffId, _date);
            } else {
                this.deselectDate(linkObj, staffId, _date);
            }
        },
    
        checkDragging: function (linkObj, staffId, _date)
        {
            if (this.current_action == false) {
                return false;
            }
            if (this.current_staff != staffId) {
                this.stopDragging();
                return false;
            }
            if (this.current_action == 'selecting') {
                this.selectDate(linkObj, staffId, _date);
            } else {
                this.deselectDate(linkObj, staffId, _date);
            }
        },
    
        stopDragging: function ()
        {
            this.current_staff = 0;
            this.current_action = false;
        },
    
        nameFieldOnFocus: function (blockNum, nameFieldId, valueFieldId, group)
        {
            callbackFunc = function (obj) {
                $(valueFieldId).value = obj.id;
                cpac.event.proSchedule.selectStaff(obj, blockNum);
    
            }
            return nameFieldOnFocus(nameFieldId, valueFieldId, group, false, null, null, true, callbackFunc );
        },
    
        selectStaff: function (obj, blockNum)
        {
            var divObj = $('staff_place_' + blockNum);
            if (divObj) {
                    // save name
                var nameInput = $('s_n-' + blockNum);
                if (nameInput) {
                    divObj.removeChild(nameInput);
                }
                var nameInput = this.getNewHiddenInput('s_n-' + blockNum, 's_n[' + blockNum + ']',  obj.value);
                divObj.appendChild(nameInput);
    
                    // save id
                var idInput = $('s_id-' + blockNum);
                if (idInput) {
                    idInput.value = obj.id;
                } else {
                    var idInput = this.getNewHiddenInput('s_id-' + blockNum, 's_id[' + blockNum + ']', obj.id);
                    divObj.appendChild(idInput);
                }
    
                    // view name box
                var boxDiv = document.createElement('div');
                boxDiv.className = 'fb-user-box';
                boxDiv.setAttribute('id', 'staff_title-' + blockNum);
                var html = '<a onclick="cpac.event.proSchedule.deselectStaff(\'' + blockNum + '\')" href="javascript:void(0)" class="fb-user-box-close"></a>';
                html += '<a href="/user/edit/?id=' + obj.id + '" class="fb-user-box-title">' + obj.value + '</a>';
                boxDiv.innerHTML = html;
                divObj.appendChild(boxDiv);
    
                var allowMultipleObj = $('a_m-' + blockNum);
                var eventObj = $('e-' + blockNum);
                if (allowMultipleObj && allowMultipleObj.value > 0) {
                    var eventBlock = $(divObj.parentNode);
                    var addInput = eventBlock.down('.add_pro_input');
                    if (!addInput || addInput == 'undefined') {
                        // add extra line
                        newNum = 'js_' + this.current_add_input_num;
                        this.current_add_input_num ++;
    
                        newDIv = document.createElement('div');
                        newDIv.setAttribute('id', 'staff_place_' + newNum);
    
                        var nameInput = this.getNewStaffInput(newNum);
                        newDIv.appendChild(nameInput);
    
                        var idInput = this.getNewHiddenInput('s_id-' + newNum, 's_id[' + newNum + ']', '0');
                        newDIv.appendChild(idInput);
    
                        var eventInput = this.getNewHiddenInput('e-' + newNum, 'e[' + newNum + ']', eventObj.value);
                        newDIv.appendChild(eventInput);
    
                        var resInput = this.getNewHiddenInput('r-' + newNum, 'r[' + newNum + ']', '0');
                        newDIv.appendChild(resInput);
    
                        var multInput = this.getNewHiddenInput('a_m-' + newNum, 'a_m[' + newNum + ']', '1');
                        newDIv.appendChild(multInput);
    
                        eventBlock.appendChild(newDIv);
                    }
    
                }
            }
        },
    
        getNewStaffInput: function(blockNum)
        {
            var defaultText = 'Add a Pro';
            var nameInput = document.createElement('input');
            nameInput.setAttribute('type', 'text');
            nameInput.setAttribute('id', 's_n-' + blockNum);
            nameInput.setAttribute('name', 's_n[' + blockNum +']');
            nameInput.setAttribute('value', defaultText);
            nameInput.setAttribute('autocomplete', 'off');
            nameInput.setAttribute('onfocus', "if (this.value == '" + defaultText + "') this.value=''; cpac.event.proSchedule.nameFieldOnFocus('" + blockNum + "', this,'s_id-" + blockNum + "', 'staff');");
            nameInput.className = 'add_pro_input';
            return nameInput;
        },
    
        getNewHiddenInput: function(id, name, value)
        {
            var idInput = document.createElement('input');
            idInput.setAttribute('type', 'hidden');
            idInput.setAttribute('id', id);
            idInput.setAttribute('name', name);
            idInput.setAttribute('value', value);
            return idInput;
        },
    
        deselectStaff: function (blockNum)
        {
            var divObj = $('staff_place_' + blockNum);
            if (divObj) {
                    // remove staff title box
                var titleInput = $('staff_title-' + blockNum);
                if (titleInput) {
                    divObj.removeChild(titleInput);
                }
                // change name input
                var nameInput = $('s_n-' + blockNum);
                if (nameInput) {
                    divObj.removeChild(nameInput);
                }
    
                var nameInput = this.getNewStaffInput(blockNum);
                divObj.appendChild(nameInput);
    
                // reset id
                var idInput = $('s_id-' + blockNum);
                if (idInput) {
                    idInput.value = '0';
                } else {
                    var idInput = this.getNewHiddenInput('s_id-' + blockNum, 's_id[' + blockNum + ']', '0');
                    divObj.appendChild(idInput);
                }
            }
        }
    
    }
    
    cpac.event.proPayrollRates = {
        classPrefix: 'staff_row_',
        idAbbr: '_ID_',
        lastRowClass: 'last',
        addPro: function(trRow, idInput) {
            if (idInput.value == '' || idInput.value == '0') {
                return;
            }
    
            var lastRow = trRow.previousSibling;
            var newRow = cpac.table.duplicateLine(lastRow, false, 'before');
    
            var nameInput = idInput.previousSibling;
            var captionParent = nameInput.parentNode;
    
            $(newRow).down('.fb-user-box-title').innerHTML = nameInput.value;
            $(newRow).down('.add_pro_input').value = nameInput.value;
            $(newRow).down('.add_pro_id').value = idInput.value;
    
            var staffId = idInput.value;
            var className = this.classPrefix + staffId;
    
            // update id value
            var inputs = $(newRow).getElementsByTagName('input');
            for(i=0; i<inputs.length; i++) {
                inputs[i].name = inputs[i].name.replace(this.idAbbr, staffId);
            }
    
            var selects = $(newRow).getElementsByTagName('select');
            for(i=0; i<selects.length; i++) {
                selects[i].name = selects[i].name.replace(this.idAbbr, staffId);
            }
    
    
                // find staff rows
            var staffRow = $(trRow.parentNode).down('.' + className);
            if (staffRow) {
                var nextRow = $(staffRow).next();
                while (nextRow && $(nextRow).hasClassName(className)) {
                    staffRow = nextRow;
                    nextRow = $(staffRow).next();
                }
    
                cpac.table.insertAfter(staffRow, newRow);
                $(staffRow).removeClassName(this.lastRowClass);
            }
    
            newRow.className = className + ' ' + this.lastRowClass;
            $(newRow).show();
    
                // clear "add pro" searchbox
            setTimeout( function () {
                var caption = $(captionParent).down('.fb-user-box');
                if (caption) cpac.autocomplete.staff.clear(caption);
            }, 10);
        },
        delPro: function (trRow) {
            var classNames = trRow.className;
            var pos = classNames.indexOf(this.classPrefix);
            var staffId = parseFloat(classNames.substr(pos + this.classPrefix.length));
    
            if (isNaN(staffId)) {
                cpac.log(staffId + ' is not a number');
                return;
            }
    
                // mark previous row as last, if this was a last row
            var nextRow = trRow.nextSibling;
            if (nextRow == undefined || !$(nextRow).hasClassName(this.classPrefix + staffId)) {
                var prevRow = trRow.previousSibling;
                $(prevRow).addClassName(this.lastRowClass);
            }
                // remove this row
            trRow.parentNode.removeChild(trRow);
        }
    }

}